"use client";
import { Check } from "lucide-react";
import { usePatientDetailsContext } from "@/features/patient/context/PatientDetailsContext";
import CardBlock from "@/features/payment/components/CardBlock";

export function StaffCardSavedView() {
  const { patient } = usePatientDetailsContext();
  return (
    <div className="flex flex-col items-center gap-4 pt-8 pb-4">
      <div className="animate-icon-pop bg-success-teal flex size-16 items-center justify-center rounded-full">
        <Check
          className="animate-icon-draw size-8 text-white"
          strokeWidth={2.5}
        />
      </div>
      <p className="m-0 text-[15px] font-bold">Card added on file</p>
      {patient?.cardOnFile && (
        <CardBlock
          cardProps={{ card: patient.cardOnFile, hideCcofChip: false }}
        />
      )}
    </div>
  );
}
